/* eslint-disable react/sort-comp */
/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Form, Button, Image, Dimmer, Loader, Grid } from 'semantic-ui-react'
import moment from 'moment'
import _ from 'lodash'
import ImageCompressor from 'image-compressor.js'
import Select from 'react-select'

import ImageUpload from '../../services/ImageUpload'
import RestaurantActions from '../../reducers/restaurantReducer'
import SponsorActions from '../../reducers/sponsorReducer'
import firebase from '../../config/firebase'

const BANNER_TYPES = [{ value: 'image', label: 'Image' }, { value: 'restaurant', label: 'Restaurant' }]
const PLACEMENT = [
  { value: 'entry_point_happening', label: 'Entry Point Happening' },
  { value: 'entry_point_new', label: 'Entry Point New' },
  { value: 'food', label: 'Food' },
  { value: 'mart', label: 'Mart' },
]

class SponsorForm extends Component {
  state = {
    image: null,compressImage: null,
    restaurant: null,
    createdAt: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    expiredAt: Number(
      moment()
        .endOf('month')
        .format('x')
    ),
    bannerType: null,
    compressing: false,
    uploading: false,
    saving: false,
    placement: 'entry_point',
    url: '',
  }

  componentDidMount() {
    const { restaurantLoaded, fetchRestaurants, sponsorsLoaded, getSponsors, action } = this.props

    if (!restaurantLoaded) {
      fetchRestaurants()
    }

    if (!sponsorsLoaded) {
      getSponsors()
    }

    if (action === 'edit') {
      const { sponsorData } = this.props

      this.setState({
        image: sponsorData.image,
        compressImage: sponsorData.compress_image,
        restaurant: {
          value: sponsorData.restaurantKey,
          label: sponsorData.restaurant,
        },
        bannerType: {
          value: sponsorData.banner_type,
          label: _.capitalize(sponsorData.banner_type),
        },
        createdAt: Number(sponsorData.created_at),
        expiredAt: Number(sponsorData.expired_at),
        placement: {
          value: sponsorData.placement,
          label: _.startCase(sponsorData.placement),
        },
        url: sponsorData.url || '',
      })
    }
  }

  onFormSubmit = () => {
    this.setState({ saving: true }, () => {
      this.saveData()
    })
  }

  onRangeChange(type, value) {
    let newValue

    if (type === 'createdAt') {
      newValue = moment(value)
        .startOf('day')
        .format('x')
    } else {
      newValue = moment(value)
        .endOf('day')
        .format('x')
    }

    this.setState({ [type]: Number(newValue) })
  }

  onImageChange(e) {
    const file = e.target.files[0]

    if (file) {
      this.compress(file)
    }
  }

  compress = file => {
    const self = this
    this.setState({ compressing: true })

    const imageCompressor = new ImageCompressor()

    imageCompressor
      .compress(file, { quality: 0.6 })
      .then(result => {
        self.setState({ compressing: false, uploading: true }, () => {
          console.log({ result })
          self.upload(result)
        })
      })
      .catch(() => {
        alert('There is problem while while compressing file. Please try again.')
      })
  }

  upload = async file => {
    const { firebaseKey } = this.props
    try {
      const imageUploader = new ImageUpload(file, 'image', {
        destination: `sponsors/${firebaseKey}`,
        type: `spon_image`,
        manipulation: {
          width: 720,
          height: 0,
          size: 30000,
        },
      })

      const { originalUrl, compressUrl } = await imageUploader.upload()

      this.setState({ uploading: false, image: originalUrl, compressImage: compressUrl })
    } catch (err) {
      alert('There is problem while uploading file. Please try again.', err)
    }
  }

  onChangeRestaurant = restaurant => {
    this.setState({ restaurant })
  }

  onBannerTypeChange = bannerType => {
    this.setState({ bannerType })

    if (bannerType.value === 'image') {
      this.setState({ restaurant: null })
    }
  }

  saveData() {
    const { image, compressImage, createdAt, expiredAt, restaurant, bannerType, url, placement } = this.state
    const { firebaseKey, history, user } = this.props

    if (bannerType.value === 'restaurant' && !restaurant.value) {
      alert('Please select restaurant')
      this.setState({ saving: false })
      return
    }

    const updates = {
      [`/sponsors/${firebaseKey}`]: {
        region: user.region,
        created_at: Number(createdAt),
        expired_at: Number(expiredAt),
        banner_type: bannerType.value,
        image,
        compress_image: compressImage,
        placement: placement.value,
      },
    }

    if (bannerType.value === 'restaurant') {
      updates[`/sponsors/${firebaseKey}`].restaurant = restaurant.label
      updates[`/sponsors/${firebaseKey}`].restaurantKey = restaurant.value
    } else {
      updates[`/sponsors/${firebaseKey}`].url = url
    }

    firebase
      .database()
      .ref()
      .update(updates)
      .then(() => {
        this.setState({ saving: false }, () => {
          history.push('/advertisement')
        })
      })
  }

  shouldDisabled() {
    const { image, uploading, compressing, saving, restaurant, bannerType } = this.state
    const loading = compressing || uploading || saving
    const requireRestaurant = bannerType && bannerType.value === 'restaurant'
    const isMissingRestaurant = requireRestaurant && !restaurant
    const isMissingImage = !image
    const isMissingBannerType = !bannerType

    return loading || isMissingImage || isMissingBannerType || isMissingRestaurant
  }

  generateDropDownRestaurants() {
    const { restaurants } = this.props
    const selectOptions = []

    _.map(restaurants, (restaurant, key) => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          value: key,
          label: restaurant.name,
        })
      }
    })

    return selectOptions
  }

  onPlacementChange = placement => {
    this.setState({ placement })
  }

  onUrlChange = url => {
    this.setState({ url })
  }

  render() {
    const { sponsorsLoading, restaurantLoading } = this.props
    const {
      compressing,
      uploading,
      image,
      createdAt,
      expiredAt,
      bannerType,
      restaurant,
      saving,
      action,
      placement,
      url,
    } = this.state

    const startFrom = moment(Number(createdAt)).format('YYYY-MM-DD')
    const endAt = moment(Number(expiredAt)).format('YYYY-MM-DD')

    const imageUrl = image || require('../../assets/images/placeholder-480.png')
    const loading = compressing || uploading

    return (
      <Form loading={restaurantLoading && sponsorsLoading}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Form.Field>
                <label>Start From</label>
                <input
                  type="date"
                  value={startFrom}
                  onChange={e => this.onRangeChange('createdAt', e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>To</label>
                <input
                  type="date"
                  value={endAt}
                  onChange={e => this.onRangeChange('expiredAt', e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <label>Placement</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={false}
                  isRtl={false}
                  name="type"
                  options={PLACEMENT}
                  value={placement}
                  onChange={this.onPlacementChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Banner Type</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isDisabled={false}
                  isRtl={false}
                  name="type"
                  options={BANNER_TYPES}
                  value={bannerType}
                  onChange={this.onBannerTypeChange}
                />
              </Form.Field>

              {bannerType && bannerType.value === 'restaurant' ? (
                <Form.Field>
                  <label>Restaurant</label>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isDisabled={false}
                    isRtl={false}
                    isSearchable
                    name="restaurant"
                    options={this.generateDropDownRestaurants()}
                    value={restaurant}
                    onChange={this.onChangeRestaurant}
                  />
                </Form.Field>
              ) : (
                <Form.Field>
                  <label>URL</label>
                  <input value={url} onChange={e => this.onUrlChange(e.target.value)} />
                </Form.Field>
              )}
            </Grid.Column>
            <Grid.Column>
              <Form.Field
              // disabled={!restaurant}
              >
                <label>Image (640x360)</label>
                <input
                  hidden
                  type="file"
                  accept="image/*"
                  onChange={e => this.onImageChange(e)}
                  ref={input => {
                    this.imageInput = input
                  }}
                />
                <Image
                  src={imageUrl}
                  className="image-previewer-sponsor"
                  onClick={() => this.imageInput.click()}
                  dimmer={
                    <Dimmer active={loading}>
                      <Loader />
                    </Dimmer>
                  }
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Button
          type="submit"
          disabled={this.shouldDisabled()}
          style={{ marginTop: 10 }}
          color="black"
          loading={saving}
          onClick={() => this.onFormSubmit()}
        >
          {action === 'edit' ? 'Update' : 'Save'}
        </Button>
      </Form>
    )
  }
}

const mapState = ({ auth, sponsors, restaurants }) => ({
  user: auth.data,
  restaurants: restaurants.data,
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,
  sponsorsLoaded: sponsors.loaded,
  sponsorsLoading: sponsors.loading,
  sponsors: _.reverse(
    _.map(Object.keys(sponsors.sponsors), sponsorKey => ({
      ...sponsors.sponsors[sponsorKey],
      sponsorKey,
    }))
  ),
})

const mapDispatch = {
  fetchRestaurants: RestaurantActions.fetchRestaurantsRequest,
  getSponsors: SponsorActions.getSponsors,
}

export default connect(
  mapState,
  mapDispatch
)(withRouter(SponsorForm))



// WEBPACK FOOTER //
// ./src/components/advertisement/sponsorForm.js